module.exports = __webpack_public_path__ + "static/media/BscorefundingGrantsSheet.fba3b3ae.csv";